module.exports = __webpack_public_path__ + "static/media/infoJumbo3.9fe97d57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/sllaser/images/infoJumbo3.jpg
// module id = 546
// module chunks = 0